export function safeScroll(ref: any, top: number, behavior: "smooth" | "auto") {
  if (!ref.current) return;

  if (typeof ref.current.scroll === "function") {
    ref.current?.scroll({ top, behavior });
  } else {
    ref.current.scrollTop = top;
  }
}
